// This is a modified version of `app-playbooks-trigger` component and will eventually replace it when the feature is generally available.

import { Component, Inject, OnInit, signal, WritableSignal } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { PlaybookTriggerConfigBase } from 'src/app/models/api/playbooks/playbook.model';
import {
  PlaybooksTriggerConfigInput,
  PlaybooksTriggerInput,
} from 'src/app/models/componentInputs/playbooksTriggerInput.interface';
import { PlaybooksTriggerOutput } from 'src/app/models/popups/outputs/playbooksTriggerOutput.interface';
import { ISelectOption } from 'src/app/models/selectOptions';
import { PlaybookTemplatesService } from 'src/app/services/templates/playbook/playbook-templates.service';
import {
  TriggerCoverage,
  TriggerType,
  getTriggerTypesFromCombination,
  getCombinationFromTriggerTypes,
} from './triggerMapping';

@Component({
  selector: 'app-new-playbooks-trigger',
  templateUrl: './new-playbooks-trigger.component.html',
  styleUrls: ['./new-playbooks-trigger.component.scss'],
})
export class NewPlaybooksTriggerComponent implements OnInit {
  public selectedTriggerType: TriggerType;
  public selectedTriggerCoverage: TriggerCoverage;

  public supportedTriggerTypes = TriggerType;
  public supportedTriggerCoverages = TriggerCoverage;
  public triggerTypeOptions = Object.values(TriggerType);
  public triggerCoverageOptions = Object.values(TriggerCoverage);

  public fg = new UntypedFormGroup({});

  public triggerConfig?: PlaybookTriggerConfigBase;
  public triggerFormInput: PlaybooksTriggerConfigInput;
  public isEdit = false;
  public isConfigurationValid: WritableSignal<boolean> = signal<boolean>(true);

  public resourceTypeOptions$: BehaviorSubject<ISelectOption[]> = new BehaviorSubject<ISelectOption[]>([]);

  constructor(
    public dialogRef: MatDialogRef<NewPlaybooksTriggerComponent>,
    @Inject(MAT_DIALOG_DATA) public triggerInput: PlaybooksTriggerInput,
    private _playbookTemplatesService: PlaybookTemplatesService
  ) {
    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(() => {
      this.closeWindow();
    });

    if (triggerInput.trigger) {
      const combination = getCombinationFromTriggerTypes(triggerInput.trigger.triggerType);
      this.selectedTriggerType = combination.type;
      this.selectedTriggerCoverage = combination.coverage;
      this.isEdit = true;
    } else {
      this.selectedTriggerType = TriggerType.violations;
      this.selectedTriggerCoverage = TriggerCoverage.all;
    }

    this.triggerFormInput = {
      integration: triggerInput.integration,
      triggerType: getTriggerTypesFromCombination(this.selectedTriggerCoverage, this.selectedTriggerType),
      triggerConfig: triggerInput.trigger?.configuration,
    };
  }

  public ngOnInit() {
    this.resourceTypeOptions$ = this._playbookTemplatesService.getResourceTypeOptions$();
  }

  public typeSelected(type: TriggerType) {
    if (type == this.selectedTriggerType) {
      return;
    }

    this._resetTriggerOnChange();
    this.selectedTriggerType = type;
    this.fg = new UntypedFormGroup({});
    this.triggerFormInput = {
      integration: this.triggerInput.integration,
      triggerType: getTriggerTypesFromCombination(this.selectedTriggerCoverage, this.selectedTriggerType),
      triggerConfig: this.triggerConfig,
    } as PlaybooksTriggerConfigInput;
  }

  public coverageSelected(coverage: TriggerCoverage) {
    this.selectedTriggerCoverage = coverage;
  }

  public closeWindow() {
    this.dialogRef.close({} as PlaybooksTriggerOutput);
  }

  public createOrUpdate() {
    if (this.isConfigurationValid()) {
      this.dialogRef.close({
        trigger: {
          triggerType: getTriggerTypesFromCombination(this.selectedTriggerCoverage, this.selectedTriggerType),
          configuration: this.fg.value as PlaybookTriggerConfigBase,
        },
      } as PlaybooksTriggerOutput);
    }
  }

  public setFormValidation(value: boolean) {
    this.isConfigurationValid.set(value);
  }

  private _resetTriggerOnChange() {
    this.triggerConfig = undefined;
  }
}
